import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * 郵便番号を「〒XXX-XXXX」形式にフォーマットする
 */
const formatPostalCode = (postalCode: string): string => {
  return `〒${postalCode.slice(0, 3)}-${postalCode.slice(3)}`;
};

/**
 * 身長(cm)と体重(kg)からBMIを計算する
 */
const calculateBMI = (heightCm: number, weightKg: number): string => {
  // BMI = 体重(kg) / (身長(m) * 身長(m))
  const heightInMeters = heightCm / 100;
  const bmi = weightKg / (heightInMeters * heightInMeters);

  return bmi.toFixed(1);
};

export { calculateBMI, formatPostalCode };
